/**
 * What the pointer is on across the usage charts (round 1, dataviz S5): a day lights its weekday in
 * the heatmap and its month in the ramp; a weekday row dims the other days; a month dims the days
 * outside it. One small value the usage section holds and every chart reads.
 */
import { isoWeekday } from './volume-math';

export type LinkFocus =
  | { kind: 'day'; day: string }
  | { kind: 'weekday'; weekday: number }
  | { kind: 'month'; month: string }
  | null;

/** The heatmap row (0 Monday) a focus points at, or null. */
export function weekdayRowOf(focus: LinkFocus): number | null {
  if (!focus) return null;
  if (focus.kind === 'weekday') return focus.weekday - 1;
  if (focus.kind === 'day') return isoWeekday(focus.day) - 1;
  return null;
}

/** The month (yyyy-MM) a focus points at, or null. */
export function monthOf(focus: LinkFocus): string | null {
  if (!focus) return null;
  if (focus.kind === 'month') return focus.month;
  if (focus.kind === 'day') return focus.day.slice(0, 7);
  return null;
}
